export default __webpack_public_path__ + "static/media/brands_2.2ebc1756.jpeg";